/* ============================================================================
   RENKEISEN · rk-header.js
   Dos cosas, las dos sobre la cabecera.

     1. El nav de categorias de ESCRITORIO es una barra deslizable. El
        degradado del borde derecho que indica "hay mas" vive en CSS
        (mask-image, ver rk-home.css); aca solo se detecta el final del
        scroll para quitarlo con la clase is-at-end.
     2. El menu de MOVIL es un <details> nativo. Abre, navega y cierra sin
        JavaScript, que es la razon de que sea un <details> y no un div con
        un manejador: si este archivo no corre, el visitante conserva la
        navegacion entera. Aca se agrega solo lo que el elemento nativo no
        trae, y cada pieza es una linea de la norma, no un adorno:

          Escape cierra                 WCAG 2.1.2, no atrapar el teclado
          el foco vuelve al boton       WCAG 2.4.3, orden del foco
          el tabulador no se escapa     patron de dialogo modal
          el fondo no hace scroll       el panel es la capa activa
          aria-modal solo estando abierto

        NO SE BLOQUEA EL SCROLL DEL FONDO, y llegar ahi costo dos intentos
        fallidos que conviene dejar escritos.

        El primero fue position:fixed sobre el body. La cabecera es sticky y
        el panel cuelga de ella con top:100%: fijar el body la saca del flujo
        de scroll y desplaza su contenido -scrollY, con lo que el sticky se
        queda sin contenedor de desplazamiento y la cabecera cae a su posicion
        estatica. Abrir el menu ya bajada la pagina se habria llevado cabecera
        y panel fuera de pantalla.

        El segundo fue overflow:hidden en <html>. No mueve ninguna caja, pero
        al dejar el viewport sin capacidad de desplazamiento el navegador
        recorta el desplazamiento actual a cero: medido, abrir el menu con la
        pagina en 1400px la mandaba de vuelta al principio, y cerrarlo la
        dejaba ahi. Cambiar un defecto de navegacion por otro no es arreglar.

        No hace falta ninguno de los dos. El panel esta anclado a una cabecera
        sticky, asi que si el fondo se desplaza el panel se desplaza con ella
        y sigue pegado donde corresponde; y un toque fuera cierra el menu en
        vez de activar lo que haya debajo. El fondo queda inerte sin que haya
        que congelarlo.
============================================================================ */
(function(){
  "use strict";

  /* ---------- 1 · nav deslizable de escritorio ---------- */
  var nav = document.querySelector('.rk-hdr__nav');
  if(nav){
    var check = function(){
      var atEnd = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 2;
      nav.classList.toggle('is-at-end', atEnd);
    };
    nav.addEventListener('scroll', check, {passive:true});
    window.addEventListener('resize', check);
    check();
  }

  /* ---------- 2 · menu movil ---------- */
  var menu = document.querySelector('[data-rk-menu]');
  if(!menu) return;
  var boton = menu.querySelector('[data-rk-burger]');
  var panel = menu.querySelector('.rk-menu__panel');
  if(!boton || !panel) return;

  var enfocables = function(){
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])'),
      function(el){ return el.offsetWidth > 0 || el.offsetHeight > 0; }
    );
  };

  var cerrar = function(devolverFoco){
    if(!menu.open) return;
    menu.open = false;
    /* preventScroll por el mismo motivo que al abrir: la hamburguesa tambien
       vive dentro de la cabecera sticky. */
    if(devolverFoco) boton.focus({ preventScroll: true });
  };

  /* El <details> nativo cambia "open" por su cuenta, asi que el estado se
     observa en vez de manejarse: pulsar el boton, pulsar Escape del navegador
     o cualquier otra via terminan en el mismo sitio y no hay dos maquinas de
     estado que puedan desincronizarse. */
  menu.addEventListener('toggle', function(){
    if(menu.open){
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-label', 'Menú de categorías');
      /* preventScroll, y no es opcional. Enfocar desplaza el elemento a la
         vista, y este panel cuelga de una cabecera sticky: a ojos del motor
         de maquetacion vive arriba del todo del documento, por mas que en
         pantalla este pegado al borde superior. Sin esto, abrir el menu con
         la pagina en 1400px la mandaba de vuelta a 0 y cerrarlo la dejaba
         ahi. Costo dos diagnosticos equivocados —primero culpe al bloqueo de
         scroll, despues a la sonda— antes de mirar quien desplazaba. */
      var f = enfocables();
      if(f.length) f[0].focus({ preventScroll: true });
    } else {
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      panel.removeAttribute('aria-label');
    }
  });

  document.addEventListener('keydown', function(ev){
    if(!menu.open) return;

    if(ev.key === 'Escape' || ev.key === 'Esc'){
      ev.preventDefault();
      cerrar(true);
      return;
    }

    if(ev.key !== 'Tab') return;
    var f = enfocables();
    /* El boton entra en el ciclo a proposito: es el que cierra, y dejarlo
       fuera obliga a salir del menu para poder cerrarlo. */
    f.unshift(boton);
    if(!f.length) return;
    var primero = f[0], ultimo = f[f.length - 1];
    if(ev.shiftKey && document.activeElement === primero){ ev.preventDefault(); ultimo.focus({ preventScroll: true }); }
    else if(!ev.shiftKey && document.activeElement === ultimo){ ev.preventDefault(); primero.focus({ preventScroll: true }); }
  });

  /* Tocar fuera cierra. En pointerdown y no en click: con el fondo sin scroll
     un gesto fuera del panel puede terminar en un arrastre que nunca llega a
     emitir click, y el menu se quedaria abierto sin manera evidente de salir. */
  document.addEventListener('pointerdown', function(ev){
    if(!menu.open) return;
    if(menu.contains(ev.target)) return;
    cerrar(false);
  });

  /* Al pasar a escritorio el panel deja de existir por CSS. Sin esto el menu
     seguiria abierto e invisible, reteniendo el foco de un panel que ya nadie
     ve y con la hamburguesa apagada para poder cerrarlo. */
  var ancho = window.matchMedia('(min-width:821px)');
  var alCambiar = function(m){ if(m.matches) cerrar(false); };
  if(ancho.addEventListener) ancho.addEventListener('change', alCambiar);
  else if(ancho.addListener) ancho.addListener(alCambiar);
})();
